/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BaseInternalError } from '../base-internal-error';
import { ErrorNames } from '../../enums';

export class AuthInternalError extends BaseInternalError {

    constructor(message?: string) {
        super(message ? `Authentication error: ${message}` : 'Authentication error');

        this.name = ErrorNames.AuthInternalError;
    }

}
